import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { YourbetMiniBetSlip } from "./YourbetMiniBetSlip";
import { YourbetMiniBetSlipData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as localMOCKTYPE from "../../mocks";
import { Parser } from "../../parser/Parser";
import { Retriever } from "../../retriever";

let _localMOCKTYPE: typeof localMOCKTYPE;
let YourBetDataMock;

if (process.env.NODE_ENV === "development") {
    _localMOCKTYPE = require("../../mocks");
    YourBetDataMock = _localMOCKTYPE.YourBetDataMock;
}

export class YourbetMiniBetSlipRoot extends BaseBlock {
    dataProvider!: YourbetMiniBetSlipData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: {},
            oddsUtil: {},
            facade: {},
            gameStatus: {},
            timeControl: {},
            panelId: "",
            storageUtils: {},
            userInfo: {}
        }
    ) {
        super(domId, options);

        if (process.env.NODE_ENV === "development") {
            // setup dictionary for debug build
            this.options.dict = BaseDict;

            // setup data mocks for debug build
            this.dataProvider = new YourbetMiniBetSlipData(
                new Parser(new Retriever(window["sbMsgBus"])),
                this.options.dict
            );

            //export data store to window for debug purposes
            window["YourbetMiniBetSlipDATA"] = this.dataProvider;
            window["YourbetMock"] = new YourBetDataMock(window["sbMsgBus"]);
            window["YourbetMock"].activate();
        }

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...config, ...(options.cms || {}) };

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            this.dataProvider = new YourbetMiniBetSlipData(
                new Parser(new Retriever(options.dataProvider)),
                this.options.dict
            );
        }
    }

    beforeActivate() {
        this.dataProvider.activate();
        return super.beforeActivate();
    }

    activate() {
        return super.activate(
            <YourbetMiniBetSlip dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["YourbetMiniBetSlip"] = YourbetMiniBetSlipRoot;
broadcastBlockLoad("YourbetMiniBetSlip");